import React from "react";
import { Spin } from "antd";

function Loading() {
  return (
    <div className="loading">
      <Spin />
      123
    </div>
  );
}

export default Loading;
